package com.exura.features.userprofile.data.repository

import com.exura.features.firebase.data.repository.BaseFirestoreRepository
import com.exura.features.userprofile.data.mappers.PolymorphicProviderProfileMappers
import com.exura.features.userprofile.data.remote.dto.UserSettingsBaseDto
import com.exura.features.userprofile.data.serialization.providerProfileSerializersModule
import com.exura.features.userprofile.domain.model.ProviderProfile
import com.exura.features.userprofile.domain.repository.BaseProviderProfileRepository
import dev.gitlive.firebase.firestore.CollectionReference
import dev.gitlive.firebase.firestore.DocumentReference
import dev.gitlive.firebase.firestore.DocumentSnapshot
import dev.gitlive.firebase.firestore.FirebaseFirestore

class BaseProviderProfileRepositoryImpl (
    firestore: FirebaseFirestore,
) : BaseProviderProfileRepository, BaseFirestoreRepository<ProviderProfile, UserSettingsBaseDto>(
    firestore = firestore,
    mapper = PolymorphicProviderProfileMappers(),
    dtoSerializersModule = providerProfileSerializersModule,
) {
    override suspend fun getDto(doc: DocumentSnapshot): UserSettingsBaseDto =
        doc.data { serializersModule = dtoSerializersModule }


    override suspend fun setDto(dto: UserSettingsBaseDto, dest: DocumentReference): DocumentReference {
        dest.set(dto) { serializersModule = dtoSerializersModule }
        return dest
    }

    override suspend fun addDto(dto: UserSettingsBaseDto, dest: CollectionReference): DocumentReference =
        dest.add(dto) { serializersModule = dtoSerializersModule }
}
